import { plural } from "../../design/format/numbers.ts";
import { artigos, listOf } from "../../design/format/text.ts";

export const peopleCopy = {
  intro: (marca: string, genero: "f" | "m") => `Quem entra na Nabla ${artigos[genero].da} ${marca}, com que papel e de quantos aparelhos. Tudo o que cada pessoa faz fica no registro com o nome dela.`,
  papeis: { admin: "admin", gestor: "gestor" },
  papel: "Papel",
  papelDe: (nome: string) => `Papel de ${nome}`,
  voce: "você",
  regras: { escreve: "Escreve regras", soLe: "Só lê as regras" },
  regrasDe: (nome: string) => `Regras de ${nome}`,
  semRegras: "não escreve regras",
  semAcesso: "sem acesso",
  ultimaAcao: (quando: string) => `última ação ${quando}`,
  hoje: (hora: string) => `hoje ${hora}`,
  aparelhos: (n: number) => (n === 0 ? "nenhum aparelho conectado" : `${n} ${plural(n, "aparelho conectado", "aparelhos conectados")}`),
  verOQueFez: "Ver o que fez →",
  encerrarSessoes: "Encerrar sessões",
  desativar: "Desativar",
  recuperarAcesso: "Se a pessoa tem uma conta vinculada, peça que entre com ela. " +
    "Para recuperar o acesso, fale com o responsável pela configuração da empresa.",
  confirmarDesativar: (nome: string) => `${nome} perde o acesso agora, em todos os aparelhos. O que fez continua no registro.`,
  desativarTitulo: (nome: string) => `Desativar ${nome}`,
  faleCom: (admin: string) => `Fale com ${admin} para convidar alguém.`,
  ou: " ou ",

  convidar: {
    botao: "Convidar pessoa",
    nome: "Nome",
    opcional: "opcional",
    criar: "Criar link",
    criando: "Criando…",
    aviso: (ate: string) => `Vale ${ate} e para uma pessoa só. Envie por um canal privado. Ele não aparece de novo.`,
    jaMostrado: "Este convite já foi criado e o link dele não aparece de novo.",
    clientes: "Clientes",
    todos: "Todos os clientes",
    semClientes: "Você não administra nenhum cliente. A pessoa entra sem clientes; quem administra um cliente dá acesso depois.",
    acesso: (papel: string, clientes: readonly string[]) =>
      (clientes.length === 0 ? `Entra como ${papel}, sem clientes.` : `Entra como ${papel} em ${listOf(clientes)}.`),
  },

  convites: {
    titulo: "Convites pendentes",
    um: (nome: string, papel: string, vence: string) => `${nome} · ${papel} · vence ${vence}`,
    semNome: "“sem nome”",
  },
} as const;
